import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Sparkles, Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function EmailVerify() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, message: "" });
  const { refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, message: "Bağlantıda geçerli bir token yok." });
      return;
    }
    api.post("/auth/verify-email", { token })
      .then((r) => {
        setState({ loading: false, ok: true, message: r.data.message || "E-postanız doğrulandı" });
        refresh();
        setTimeout(() => nav("/panel", { replace: true }), 1800);
      })
      .catch((e) => setState({ loading: false, ok: false, message: formatApiError(e) }));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-50" data-testid="verify-page">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-8 h-8 rounded-xl bg-[#1E3A8A] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display font-bold text-lg tracking-tight">SuperZeka</span>
        </Link>

        <div className="rounded-2xl border border-zinc-200 bg-white p-8 text-center">
          {state.loading && (
            <>
              <Loader2 className="w-8 h-8 text-[#1E3A8A] animate-spin mx-auto" />
              <h1 className="mt-4 font-display text-xl font-semibold text-zinc-900">Doğrulanıyor…</h1>
            </>
          )}
          {!state.loading && state.ok && (
            <>
              <CheckCircle2 className="w-10 h-10 text-[#10B981] mx-auto" />
              <h1 className="mt-4 font-display text-xl font-semibold text-zinc-900">
                E-postan doğrulandı
              </h1>
              <p className="mt-2 text-sm text-zinc-600">Panele yönlendiriliyorsun…</p>
            </>
          )}
          {!state.loading && !state.ok && (
            <>
              <XCircle className="w-10 h-10 text-red-500 mx-auto" />
              <h1 className="mt-4 font-display text-xl font-semibold text-zinc-900">
                Doğrulama başarısız
              </h1>
              <p className="mt-2 text-sm text-zinc-600">{state.message}</p>
              <Link to="/panel" className="block mt-6">
                <Button variant="outline" className="w-full rounded-full">Panele Git</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
